
// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";
const FinanceAssetCodeApprvService = {};

FinanceAssetCodeApprvService.getFinanceAssetCodeApprvList = function (
  userInput
) {
  return lossClient({
    url: "/subproductfinanceasset/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default FinanceAssetCodeApprvService;
